module.exports = __webpack_public_path__ + "static/media/MICHELL ORBE.76c6cf0e.png";